import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Shield, Lock, Mail, ArrowRight, AlertTriangle } from 'lucide-react';
export const AdminLogin = () => {
  const navigate = useNavigate();
  const handleLogin = (e: React.FormEvent) => {
    e.preventDefault();
    navigate('/admin');
  };
  return <div className="min-h-screen flex items-center justify-center bg-slate-50 dark:bg-[#0f172a] p-4 transition-colors duration-200" data-id="element-443">
      <div className="w-full max-w-md" data-id="element-444">
        <div className="text-center mb-8" data-id="element-445">
          <div className="w-16 h-16 rounded-2xl bg-secondary/10 flex items-center justify-center mx-auto mb-6 border border-secondary/20" data-id="element-446">
            <Shield size={32} className="text-secondary" data-id="element-447" />
          </div>
          <h1 className="text-3xl font-serif font-bold text-slate-900 dark:text-white mb-2" data-id="element-448">
            AMU Admin Portal
          </h1>
          <p className="text-slate-500 dark:text-slate-400" data-id="element-449">
            Secure access for authorized personnel only.
          </p>
        </div>

        <div className="bg-white dark:bg-[#1e293b] rounded-2xl shadow-2xl border border-slate-200 dark:border-slate-700 p-8 transition-colors duration-200" data-id="element-450">
          <div className="flex items-start gap-3 p-4 bg-red-50 dark:bg-red-500/10 border border-red-200 dark:border-red-500/20 rounded-xl mb-8" data-id="element-451">
            <AlertTriangle className="text-red-500 dark:text-red-400 shrink-0 mt-0.5" size={18} data-id="element-452" />
            <p className="text-xs text-red-700 dark:text-red-200 leading-relaxed" data-id="element-453">
              This is a restricted system. All activities are monitored and
              logged. Unauthorized access is strictly prohibited.
            </p>
          </div>

          <form onSubmit={handleLogin} className="space-y-6" data-id="element-454">
            <div data-id="element-455">
              <label className="block text-sm font-bold text-slate-700 dark:text-slate-300 mb-2" data-id="element-456">
                Admin Email
              </label>
              <div className="relative" data-id="element-457">
                <Mail className="absolute left-4 top-1/2 -translate-y-1/2 text-slate-400 dark:text-slate-500" size={20} data-id="element-458" />
                <input type="email" placeholder="admin@amu.ng" className="w-full pl-12 pr-4 py-3.5 rounded-xl border border-slate-200 dark:border-slate-600 bg-slate-50 dark:bg-slate-800 text-slate-900 dark:text-white focus:bg-white dark:focus:bg-slate-700 focus:ring-2 focus:ring-secondary focus:border-secondary outline-none transition-all placeholder:text-slate-400 dark:placeholder:text-slate-500" required data-id="element-459" />
              </div>
            </div>

            <div data-id="element-460">
              <label className="block text-sm font-bold text-slate-700 dark:text-slate-300 mb-2" data-id="element-461">
                Password
              </label>
              <div className="relative" data-id="element-462">
                <Lock className="absolute left-4 top-1/2 -translate-y-1/2 text-slate-400 dark:text-slate-500" size={20} data-id="element-463" />
                <input type="password" placeholder="••••••••" className="w-full pl-12 pr-4 py-3.5 rounded-xl border border-slate-200 dark:border-slate-600 bg-slate-50 dark:bg-slate-800 text-slate-900 dark:text-white focus:bg-white dark:focus:bg-slate-700 focus:ring-2 focus:ring-secondary focus:border-secondary outline-none transition-all placeholder:text-slate-400 dark:placeholder:text-slate-500" required data-id="element-464" />
              </div>
            </div>

            <button type="submit" className="w-full bg-secondary hover:bg-secondary-dark text-primary-900 py-4 rounded-xl font-bold transition-colors flex items-center justify-center gap-2 shadow-glow mt-8" data-id="element-465">
              Authenticate <ArrowRight size={18} data-id="element-466" />
            </button>
          </form>
        </div>

        <div className="text-center mt-8 text-xs text-slate-500" data-id="element-467">
          IP Address: 192.168.1.1 • Session ID:{' '}
          {Math.random().toString(36).substring(7).toUpperCase()}
        </div>
      </div>
    </div>;
};